import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import React from "react";
import DocumentsForm from "../../../common/form/document/DocumentsForm";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import useFormReset from "../../../../../../hooks/useFormReset";
import useStepDocuments from "../../../../../../hooks/useStepDocuments";
import { fileGroups } from "../../../../../../config/fileGroupConfig";
import { ApplicationType } from "@duosoftbg/nacid-components";
import {
  completeDocumentStep,
  setStepDocumentsEdited,
} from "../../../../../../store/redux/slice/Forms/rudiAdditionalDocForm";

const RudiAdditionalDocStepDocuments = () => {
  const rudiAdditionalDocForm = useAppSelector((state) => {
    return state.Forms.RudiAdditionalDocForm;
  });

  const { methods, onSubmit } = useStepDocuments(
    rudiAdditionalDocForm,
    baseEndpointPaths.rudiAdditionalDoc,
    completeDocumentStep,
    setStepDocumentsEdited,
  );

  useFormReset("RUDI_ADDITIONAL_DOCUMENTS", rudiAdditionalDocForm.documentDetails, methods.reset);

  return (
    <DocumentsForm
      methods={methods}
      onSubmit={onSubmit}
      setDocumentsFormEdited={setStepDocumentsEdited}
      hasAttachmentForm={true}
      hasAttachmentType={true}
      applicationId={rudiAdditionalDocForm.id}
      fileGroup={fileGroups.pdf}
      informingMessageCode={["m.rudi.files.info", "m.seServices.applications.info"]}
      applicationType={ApplicationType.ACADEMIC_RECOGNITION}
      applicationSubType={"RUDI_ADDITIONAL_DOCUMENTS"}
    />
  );
};
export default RudiAdditionalDocStepDocuments;
